import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app" };
const _hoisted_2 = {
    class: "content-area",
    "data-scroll-root": ""
};
import { computed, shallowRef } from "vue";
import { useRoute } from "vue-router";
import { moduleRegistry } from "./router/moduleRegistry";
import { ToastContainer } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const route = useRoute();
        // Get components from module registry
        // Note: moduleRegistry is initialized synchronously in main.ts before app.mount()
        // Use shallowRef to avoid making Vue components reactive (performance optimization)
        const HeaderComponent = shallowRef(moduleRegistry.getComponentForSlot("header"));
        const FooterComponent = shallowRef(moduleRegistry.getComponentForSlot("footer"));
        const MainSidebarComponent = shallowRef(moduleRegistry.getComponentForSlot("main-sidebar"));
        const isLogoutPage = computed(() => {
            return route.path === "/session-ended";
        });
        const scrollsAsPageOnShortViewport = computed(() => route.meta?.scrollsAsPageOnShortViewport === true);
        const hideHeader = computed(() => {
            return route.meta?.hideHeader === true;
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["app-layout", { 'no-layout': isLogoutPage.value }])
                }, [
                    (!isLogoutPage.value && MainSidebarComponent.value)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(MainSidebarComponent.value), { key: 0 }))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_2, [
                        (!isLogoutPage.value && !hideHeader.value && HeaderComponent.value)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(HeaderComponent.value), { key: 0 }))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("main", {
                            class: _normalizeClass(["main-content", { 'no-layout': isLogoutPage.value, 'scrolls-as-page-on-short-viewport': scrollsAsPageOnShortViewport.value }])
                        }, [
                            _createVNode(_component_router_view)
                        ], 2 /* CLASS */),
                        (!isLogoutPage.value && FooterComponent.value)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(FooterComponent.value), { key: 1 }))
                            : _createCommentVNode("v-if", true)
                    ])
                ], 2 /* CLASS */),
                _createVNode(_unref(ToastContainer))
            ]));
        };
    }
});
